<!--Top Nav Header Container div-->
<div class="top-nav-header-container">
  <!--Left side container div-->
  <div class="left-side-block">
    <img src="../../../assets/images/New_Icons/aqu_logo.png" height="60" width="150" class="web-toogle-icon" (click)="navigationToggleMenu()"/>
  </div>
  <!--Right side container div-->
  <div class="right-side-block">
  <li class="xn-icon-button pull-right account-status" *ngIf="businessEntity?.accountStatus == 'markedForInactivation'">
    <span>
      <img src="../../assets/images/New_Icons/alert-danger-without-fill.svg" width="40px" height="40px">
    </span>
    <div>
      <span class="status-message">This account is marked for closure.</span><br>
      <span><a routerLink="/home/account-closure" class="cancel-link-message">Click here to cancel</a></span>
    </div>
  </li>
    <!--Profile Block-->
    <div (mouseenter)="showProfile()" (mouseleave)="hideProfile()" class="user_profile_content-web">
      <div class="user_info">
        <div class="user-details profile-web-view">
          <img src="../../../assets/images/New_Icons/login-user-icon.svg" height="35" width="35" class="profile-image" *ngIf="!loginUserBusinessIcon">
          <img src="{{loginUserBusinessIcon}}" height="35" width="35" class="profile-image" *ngIf="loginUserBusinessIcon">
          <div class="user-name">
            <span class="userName" [title]="LoginUserName">{{LoginUserName}}</span><span class="personRole">{{loginPersonType}}</span>
          </div>
        </div>
        <div class="profile-mobile-view">
          <img src="{{loginUserBusinessIcon}}" class="mobile-profile-image" *ngIf="loginUserBusinessIcon">
          <span class="mobile-no-profile-image" *ngIf="!loginUserBusinessIcon"></span>
        </div>
      </div>
      <div class="userProfile" [class.visible]="isNotificationsOpen">
        <div class="profile-info-div">
          <span class="welcome-text">Welcome</span>
          <div class="sub-user-details">
            <img src="../../../assets/img/users/no-logo.svg" height="35" width="35" class="profile-image" *ngIf="!loginUserBusinessIcon">
            <img src="{{loginUserBusinessIcon}}" height="35" width="35" class="profile-image" *ngIf="loginUserBusinessIcon">
            <div class="user-name">
              <span class="user-name-text">{{LoginUserName}}</span>
              <span class="person-role-text">{{loginPersonType}}</span>
            </div>
          </div>
        </div>
        <div>
          <div class="buttons-div">
            <div class="button-container" (click)="logout()">
              <button>
                <span class="icon"><img src="../../../assets/images/New_Icons/signout-icon.svg"></span>
                <span class="text">Log Out</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Toogle Icon for drawer based menu-->
    <img src="../../../assets/images/navigation_menu.svg" alt="" height="50" class="mobile-toogle-icon" *ngIf="redirectTo == ''" (click)="onToggleMenu()">
  </div>
</div>
